export default ({
  state: {
    msg: 'hello demo',
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
});
